//
// Copyright © 2024 Hardcore Engineering Inc.
//

import { sign, signId } from './plugin'

export * from './utils'

export { signId }

export default sign
